<?xml version="1.0" encoding="UTF-8" standalone="no"?>
<svg
   viewBox="0 0 96.734901 39.899506"
   version="1.1"
   xml:space="preserve"
   id="svg45"
   xmlns:xlink="http://www.w3.org/1999/xlink"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg">
<path
   fill="none" stroke="#979595" stroke-width="4.167" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="2"
   d="M 2.0834999,37.816005 V 2.0834045 L 94.6514,37.816005"
   id="path50" /></svg>
